import * as React from "react";
import { PurchaseTypeSelectionBoxes } from "./PurchaseTypeSelectionBoxes.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { updatePurchaseType } from "../../../../../../../../context/context/actions.js";
const PurchaseTypeSelectionBoxesContainer = ({ className, onSelection }) => {
  const {
    activeVariant: {
      purchaseTypePrices,
      isAvailableForSubscription,
      isAvailableForInStoreSubscription
    },
    dispatch,
    selectedPurchaseType
  } = useProductData();
  const handleSelection = React.useCallback(
    (purchaseType) => {
      dispatch(updatePurchaseType({ purchaseType }));
      onSelection?.(purchaseType);
    },
    [dispatch, onSelection]
  );
  return /* @__PURE__ */ React.createElement(
    PurchaseTypeSelectionBoxes,
    {
      className,
      isAvailableForInStoreSubscription,
      onSelection: handleSelection,
      purchaseTypePrices,
      selectedPurchaseType,
      subscriptionTypeAllowed: isAvailableForSubscription
    }
  );
};
export {
  PurchaseTypeSelectionBoxesContainer
};
//# sourceMappingURL=PurchaseTypeSelectionBoxesContainer.js.map
